// filepath: motor-risk.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from '../service/env/env.service';

export interface MotorRisk {
  id: number;
  tabledCode: number;
  tabledDesignation: string;
  enabled: boolean;
  deleted: boolean;
  createdAt: string;
  createdBy: string | null;
  modifiedAt: string;
  modifiedBy: string | null;
}

export interface MotorRiskListResponse {
  responseCode: string;
  responseMessage: string;
  data: {
    totalItems: number;
    risks: MotorRisk[];
    totalPages: number;
    currentPage: number;
  };
}

export interface MotorRiskResponse {
  responseCode: string;
  responseMessage: string;
  data: MotorRisk;
}

export interface MotorRiskRequest {
  tabledCode: number | null;
  tabledDesignation: string;
  enabled: boolean;
}

export interface DiscountFlagResponse {
  id: number;
  allowDiscount: boolean;
  userId: number;
  createdOn: string;
  createdBy: string | null;
  updatedOn: string | null;
  updatedBy: string | null;
}

/** Payload for PUT /vehicle-risk/{id} — only the editable fields */
export interface MotorRiskUpdateRequest {
  tabledCode: number | null;
  tabledDesignation: string;
}

@Injectable({ providedIn: 'root' })
export class MotorRiskService {
  private activeUrl: string;

  constructor(private http: HttpClient, private env: EnvService) {
    this.activeUrl = this.env.apiUrl;
  }

  getAllRisks(enabledFilter: boolean | null = null): Observable<MotorRiskListResponse> {
    let url = `${this.activeUrl}/vehicle-risk?page=0&size=1000`;
    if (enabledFilter !== null) {
      url += `&enabled=${enabledFilter}`;
    }
    return this.http.get<MotorRiskListResponse>(url);
  }

  createRisk(payload: MotorRiskRequest): Observable<MotorRiskResponse> {
    return this.http.post<MotorRiskResponse>(`${this.activeUrl}/vehicle-risk`, payload);
  }

  updateRisk(id: number, payload: MotorRiskUpdateRequest): Observable<MotorRiskResponse> {
    const body: MotorRiskUpdateRequest = {
      tabledCode:        payload.tabledCode,
      tabledDesignation: payload.tabledDesignation
    };
    return this.http.put<MotorRiskResponse>(`${this.activeUrl}/vehicle-risk/${id}`, body);
  }

  toggleEnabled(id: number, enabled: boolean): Observable<MotorRiskResponse> {
    return this.http.put<MotorRiskResponse>(
      `${this.activeUrl}/vehicle-risk/${id}/enabled?enabled=${enabled}`,
      { enabled }
    );
  }

  deleteRisk(id: number): Observable<MotorRiskResponse> {
    return this.http.delete<MotorRiskResponse>(`${this.activeUrl}/vehicle-risk/${id}`);
  }

  getDiscountFlag(): Observable<DiscountFlagResponse> {
    return this.http.get<DiscountFlagResponse>(`${this.activeUrl}/get/discount-flag`);
  }

  setDiscountFlag(setFlag: boolean): Observable<DiscountFlagResponse> {
    return this.http.put<DiscountFlagResponse>(`${this.activeUrl}/set/discount-flag`, { setFlag });
  }
}
